// extracted by mini-css-extract-plugin
export default {"title":"ConfirmModal_title__Q26fw","icon":"ConfirmModal_icon__KXASp","content":"ConfirmModal_content__p6Ozk"};